/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import {Breakpoints} from "../../../../constants/Breakpoints";

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  
  `;

  export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
`;

export const InlineLabel = styled(Text)`
  display: inline-flex;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  text-transform: none;
  
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 5px 0;
    background-color: ${Colors.GRAY[4]}; 
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  background-color:#FFF; 
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`

export const AttachmentContainer = styled.section`
border: 1px solid ${Colors.BLUE};
background: #fff;
margin-bottom: 40px;
height: 200px;
overFlow: auto;
width: 100%;
`;
